module.exports = __webpack_public_path__ + "static/media/clean-ginssen-icon-02.33c23bc2.png";